<template>
    <div >
     <CustomCallout       
        :has-toggle="false"
        class="mt-2 deep"
        :border-color-hex="'#FF7058'"
        >
            <icon-view
                :has-border="false"
                icon="fas fa-exchange color-white mb-1"
                icon-size="0.9rem"
                iconBackground="#FF7058"
                title="Cambiar Estatus"
                variant="mt-2"
                />   
            <ValidationObserver ref="form" tag="div" class="row">  
                <div class="col-12 pt-2">   
                    <div class="row mt-5 pb-3">
                      <div class="col-md-6">
                        <div class="col-md-12">            
                            <ValidationProvider 
                                v-slot="{ errors }"
                                :rules="'required'"
                                :custom-messages="{
                                required: 'Favor de seleccionar el estatus.'
                                }"
                            >
                                <CustomDropDown
                                    v-model="status"
                                    label="Estatus:"
                                    placeholder="Seleccione"
                                    required
                                    fieldkey="id"
                                    fieldname="name"
                                    :options="filters"
                                    :error="errors[0]"
                                    :custom-error-msg="errors[0]"
                                />
                            </ValidationProvider>                         
                        </div>                        
                        <div class="col-12 mb-2 mt-2" v-if="isRecomended">
                            <ValidationProvider
                            v-slot="{ errors }"
                            mode="lazy"
                            rules="required"
                            >
                              <label>Nombramiento de Asistente</label>
                                <custom-input
                                  label="Número de Autorización:"
                                  v-model="authorizationNumber"
                                  placeholder="Escriba Número de Autorización"                                  
                                  :error="errors[0]"
                                  custom-error-msg="Favor de registrar el número de autorización."
                                />
                            </ValidationProvider>                          
                        </div>                                             
                      </div>                                                                     
                      <div class="col-md-6">   
                          <ValidationProvider 
                                  v-slot="{ errors }"
                                  :rules="'required'"
                                  :custom-messages="{
                                  required: 'Favor de registrar un comentario.'
                                  }"
                              >                         
                              <CustomTextArea
                                  v-model="reason"
                                  label="Comentario:"
                                  :maxlength="3000"
                                  show-char-count
                                  :error="errors[0]"
                                  :custom-error-msg="errors[0]"
                              />
                          </ValidationProvider>   
                        </div>                
                    </div>
                </div>
            </ValidationObserver>   
                <div class="row">
                    <div class="col-12 pt-2 text-right">
                        <ActionButton
                            class="m-1"
                            text="Cancelar"
                            variant="outline-danger"
                            i="fas fa-times-circle"
                            @click="onCancel"
                        />
                        <ActionButton
                            class="m-1"
                            text="Guardar"
                            variant="success"
                            i="fas fa-save"
                            @click="onContinue"
                        />
                   </div> 
                </div> 
        </CustomCallout>
    </div>
</template>
  
<script>


import CustomCallout from "custom-callout";
import IconView from "icon-view";
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from 'CustomTextArea'
import ActionButton from "ActionButton";
import CustomRadioButton from "custom-radio";
import CustomInput from "CustomInput";
import { requestStatusCodes } from "@/utils/constants/hrrequest/requestStatusCodes";
export default {
    name: "ContainerStatusChange",
    components: {
        CustomCallout,
        IconView,
        CustomDropDown,
        CustomTextArea,
        ActionButton,
        CustomRadioButton,                
        CustomInput
    },
    props:{
        filters:null,
        academicYearId:null,        
    },
    data() {
      return {
      status:null,
      reason:null,
      authorizationNumber: null,      
    };
  },
  computed:{    
    isRecomended(){
      return this.status?.id==requestStatusCodes.recomended
    },    
  },
  methods:{
    onCancel(){
        this.$emit('close')
    },
     async onContinue(){
        const isValid = await this.$refs.form.validate();
        if(!isValid){
            return;
        }
        let dataToUpdate={           
            reason:this.reason,
            authorizationNumber: this.authorizationNumber,            
            status:this.status
        }
        this.$emit('accept',dataToUpdate)
    },    
    getResultValue(result) {
      return result.displayName;
    },    
  }, 
};
</script>

<style scoped>
.tab__container {
  padding: 20px 30px;
}

.action-buttons__container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
}

.dot-icon__container {
  padding: 3px 5px;
  border-radius: 50%;
  box-shadow: 0 3px 6px #00000029;
  background: #fff 0 0 no-repeat padding-box;
}

::v-deep .custom-text-area__container textarea {
  min-height: 50px !important;
}
::v-deep #dropdownMenuButton.btn-change-status {
  background-color: transparent !important;
  color: #2db782 !important;
}
.container-autocomplete{
    width: 32.4%;
}
</style>